import React from "react";
import { Link } from "react-router-dom";
import RoomC from "../components/RoomC"
// const pt120 = {
//     paddingTop: '200px',
// };
const Room = () => {
    return (
        <main>
            <section className="blog-banner-area" id="about">
                <div className="container h-100">
                    <div className="blog-banner">
                        <div className="text-center">
                            <h1>Our Rooms</h1>
                            <nav aria-label="breadcrumb" className="banner-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link className="nav-link" to={"/"}>Home</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Our Rooms</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section-margin section-margin--small">
                <div className="container">
                    <div className="section-intro text-center pb-80px">
                        <div className="section-intro__style">
                            <img src="img/home/bed-icon.png" alt="" />
                        </div>
                        <h2>Explore Our Rooms</h2>
                    </div>

                    {/* Rooms  */}
                    <RoomC />

                </div>
            </section>
        </main>

    );
};

export default Room;